import React, { useCallback, useContext } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE } from 'pathnames.js';
import { SORT_ORDER } from 'globals.js';

// GLOBAL HELPERS
import { getListData, ListContext } from 'helpers/getListData';

// CORE COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table.js';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from '../../../../columns.js';

// LOCAL COMPONENTS
import EpostButton from './parts/EpostButton.js';
import RebillEpostSidebar from './parts/RebillEpostSidebar.js';
import ExcelButtons from '../../tools/ExcelButtons';

// MAIN COMPONENT
const Rebilled = () => {
  // CONTEXT
  const {
    data: {
      incomplete_rebilled_eposts = 0
      // total_records = 0
    },
    // preferences,
    updateFilter
  } = useContext(ListContext) || {};

  // CALLBACKS
  const handleUpdate = useCallback(
    (value, name) => {
      updateFilter({
        [name]: value
      });
    },
    [updateFilter]
  );

  return (
    <>
      <Main>
        <Title
          documentTitle="Delivery Log -> Rebilled Ledger"
          title="Rebilled Ledger"
          className="d-flex align-items-center"
          tools={
            <>
              <ExcelButtons fileName="delivery_log_rebilled_ledger" />
              <Button
                variant="warning"
                label={<>Incomplete E-Posts {incomplete_rebilled_eposts}</>}
                onClick={() => handleUpdate(true, 'incompleteRebilledEposts')}
              />
              <Button icon="cancel" onClick={() => handleUpdate(false, 'incompleteRebilledEposts')} />
            </>
          }
        />
        <Filters>
          <Filters.Date.Range dropdown={{ maxHeight: '350px' }} />
          <Filters.Button.SalesType />
          <Filters.Button.NewUsed />
          <Filters.Search />
        </Filters>
        <Table
          // heading={
          //   <span>
          //     Rebill Ledger -{' '}
          //     {preferences?.filters?.salesType === 'R'
          //       ? 'Retail - '
          //       : preferences?.filters?.salesType === 'W'
          //       ? 'Wholesale - '
          //       : ''}
          //     {preferences?.filters?.newUsed === '1'
          //       ? 'New'
          //       : preferences?.filters?.newUsed === '0'
          //       ? 'Pre-Owned'
          //       : 'All'}
          //     {` (${total_records})`}
          //   </span>
          // }
          mobilePreviewKeys={['customer1', 'date_adjusted', 'vehicle']}
          showNumber
        />
      </Main>
      <RebillEpostSidebar.List />
    </>
  );
};

// EXPORT
export default getListData(Rebilled, {
  key: 'deliveryLogRebilled',
  fetchArgs: {
    endpoint: ENDPOINTS.deliveryLog.list
  },
  defaults: {
    deliveryLogType: 'R',
    incompleteRebilledEposts: false,
    startDate: Form.Date.OPTIONS.thisYear.startDate,
    endDate: Form.Date.OPTIONS.thisYear.endDate,
    order: SORT_ORDER.descending,
    sort: 'date_adjusted'
  },
  columns: [
    {
      key: 'date_adjusted',
      label: 'Adjust Date',
      width: 125,
      component: Table.DateTime
    },
    {
      key: 'adjusted_by',
      label: 'Adjusted By',
      width: 80
    },
    COLUMNS.deliveredDate,
    COLUMNS.newUsed,
    COLUMNS.purchaseLease,
    {
      ...COLUMNS.retailWholesale,
      key: 'sale_type'
    },
    {
      ...COLUMNS.customer(),
      key: 'customer1',
      key2: 'customer2'
    },
    COLUMNS.stockNumber,
    {
      ...COLUMNS.makeModel,
      key: 'vehicle',
      width: 90
    },
    COLUMNS.frontendGross,
    COLUMNS.frontendGrossAdjust,
    COLUMNS.frontendGrossNew,
    COLUMNS.backendGross,
    COLUMNS.backendGrossAdjust,
    COLUMNS.backendGrossNew,
    {
      ...COLUMNS.salesPerson,
      key: 'salesperson1',
      key2: 'salesperson2'
    },
    COLUMNS.fmManager,
    {
      component: EpostButton,
      key: 'epost_button_enabled',
      label: 'E-post',
      width: 50
    }
  ],
  actions: [ACTIONS.open(INTERFACE.sales, 'sales_id')],
  sortable: true
});
